export const DISALLOW_FREE_CANCELLATION_EXPERIENCE_IDS = new Set<string>([
  // tour-4f7e366d-817d-40f2-b3d0-a9a47b156426
  // Qatar return economy flights
  '987638be-ef6e-48ac-bb6d-9c41520b90a1',
  // Qatar return business class flights
  '2b44f138-2d94-4296-bcdc-187d731d8db3',

  // tour-f140afb3-543e-495f-8fdf-fd0a6038cd7d
  // Qatar return economy flights
  'f7a70068-5f93-45c1-9341-3def36be18d3',
  // Qatar return business class flights
  '95f99fcb-410f-4bd3-aaa9-8f266559a21e',

  // tour-89e5f38a-ff81-47f1-96d9-bdd611c13dcb
  // Qatar return economy flights
  'b1b846e1-5359-4009-bd96-64ea381cddb7',
  // Qatar return business class flights
  'db507097-6199-4ea9-868b-edc55c3002bc',

  // tour-c5c577e7-f086-47ea-a318-22f25497a6ff
  // Cruise Cabin Upgrade to Aquamarine Veranda Suite (Middle) (Solo)
  '8a619621-39d4-42c4-918a-a5f2272880e9',
  // Cruise Cabin Upgrade Sapphire Veranda Suite (Forward)
  'db1a6717-e800-484a-a8a2-08f492c636f1',
  // Cruise Cabin Upgrade: Sapphire Veranda Suite (Forward) (Solo)
  'ff3514a9-6bf0-4ae4-9376-21ca188483e3',
  // Cruise Cabin Upgrade: Aquamarine Veranda Suite (Middle)
  'fb67b100-fa2e-4e8e-bb3a-d8a3c84872c9',
  // Cruise Cabin Upgrade: Aquamarine Veranda Suite (Middle)
  'ae556068-30f9-4cfc-81ff-794831e0d2d8',
  // Cruise Cabin Upgrade: Sapphire Veranda Suite (Middle) (Solo)
  '710c29a2-e638-4198-bfe4-90ec2c48a39f',

  // tour-3fca9931-9359-4f30-b7a0-5769cf691d77
  // Cruise Cabin Upgrade: Aquamarine Veranda Suite (Middle) (Solo)
  'bf6e465c-99a8-49b0-95de-5ffb88b6dbb3',
  // Cruise Cabin Upgrade: Aquamarine Veranda Suite (Middle)
  '13ec091b-ce66-4a5e-9ea9-62e3d68ade09',
  // Cruise Cabin Upgrade: Sapphire Veranda Suite (Middle) (Solo)
  'cf5b724b-6f22-406e-b637-e54b20e54a29',
  // Cruise Cabin Upgrade: Aquamarine Veranda Suite (Middle)
  'f213a080-b74a-4d83-99f5-f59cd6886fef',
  // Cruise Cabin Upgrade: Sapphire Veranda Suite (Forward)
  'f042babb-74b2-4d2a-8446-b066edae2db7',
  // Cruise Cabin Upgrade: Sapphire Veranda Suite (Forward) (Solo)
  '17120bd5-2d60-4a6d-8468-a7dea282b197',

  // tour-f8d33f67-7fcc-4abf-9a65-87c8e589a958
  // Upgrade from Harmony Suite to Riverside Suite onboard Riverside Mozart (on request)
  'ded067cf-f238-4c24-8509-f2b5cc479c9a',

  // tour-ce58e8f7-d9f3-4b43-830b-569da358c1f4
  // Mozart dinner & concert with transfers
  '2b5c1be5-a285-469c-963d-d8494cd460bc',
  // Upgrade from Riverside Suite to Penthouse Suite onboard Riverside Mozart (on request)
  'd6181f3a-f74b-4906-ae13-a90efba551f0',
  // Upgrade from Harmony Suite to Riverside Suite onboard Riverside Mozart (on request)
  '3b2df012-5eb3-4f35-b773-4b381af8fcca',

  // tour-e68deb8e-7d94-4aed-8bc9-163b4b158ff0
  // Santiago Gallegan dinner with queimada
  '726c8c51-4682-4d2a-820d-33715a280575',
  // Lisbon fado dinner
  'b92b53f4-7ce5-4338-8e38-af4a14ee869b',
  // Toledo half-day tour
  'b6b4cd66-5d43-4832-83b5-60b7b7fe18d0',
  // Upgrade to Balcony Suite aboard Scenic Azure (Category PA/B)
  'c8589526-63e2-4498-af29-969869d01a5e',
  // Upgrade to Balcony Suite aboard Scenic Azure (Category P)
  'f47d1e68-0581-4a52-aaab-5f4e49c03d1d',

  // tour-03011881-22e4-4454-9f55-797c972095c0
  // Azamara Journey room upgrade: Verandah Stateroom – Twin Share
  '9e671ee4-c1f1-495a-84fa-2f8fc6f70a83',
  // Azamara Journey room upgrade: Oceanview Stateroom – Solo
  '8b9b84ec-2944-4801-b85b-dc4631f0dbb4',
  // Azamara Journey room upgrade: Oceanview Stateroom – Twin Share
  'b0c153dc-adc5-40e0-8a17-a968f14645a6',
  // Azamara Journey room upgrade: Verandah Stateroom – Solo
  '2bc7d9a7-07e9-4feb-b19a-72f7e3dc511f',

  // tour-f52d1e3b-2352-4e43-8bf8-dba2832e176e
  // Cruise cabin upgrade to Cat A3 (concierge veranda) – TWIN SHARE
  'd4d076a3-2020-4904-a9b3-13454b5bc42f',
  // Cruise cabin upgrade to Cat A3 (concierge veranda) – SOLO
  '0c80beb9-378e-46f0-b229-744ff9a551c0',
  // Cruise cabin upgrade to Cat B2 (veranda stateroom) – SOLO
  '6a2481e3-9123-4684-b3d7-1212e2828069',
  // Cruise cabin upgrade to Cat B2 (veranda stateroom) – TWIN SHARE
  '2bb1b712-52f3-42e2-9948-8fd56f6aa2a2',

  // tour-a02a5d0f-b718-4648-8cb6-f567afaa1eae
  // Qatar return business class flights
  '117fb57d-030e-4c56-98e5-706d7d332d89',

  // tour-febcd975-3fc1-4309-b09f-1c3778b1731a
  // Cruise Cabin Upgrade: Category A Balcony Suite
  '8776cffb-46c6-4022-af0e-3ddbd2f47baf',

  // tour-0e91353b-ca79-4cca-9737-5f681a685e70
  // Cruise Cabin Upgrade: Sapphire Deluxe Suite (Cat B)
  '13ad15b0-0e50-44b6-9d4e-71387c93de88',
  // Cruise Cabin Upgrade: Sapphire Deluxe Suite (Cat BA)
  '8886f373-050d-46d6-ac10-915fa44ae0f8',
  // Cruise Cabin Upgrade: Sapphire Deluxe Suite (Cat B) (solo)
  'a96daae5-6427-48d9-87a6-4d185b194331',
  // Cruise Cabin Upgrade: Sapphire Deluxe Suite (Cat BA) (solo)
  'cc747bbf-62ad-43f9-b8fc-7cd946866fd8'
])

export function shouldShowFreeCancellationForTourExperience(
  experience: App.Tours.TourExperience | undefined,
): boolean {
  return !!(
    experience
    && !DISALLOW_FREE_CANCELLATION_EXPERIENCE_IDS.has(experience.id)
  )
}
